/**
 * @file The Entitled photos Identity Filter Reducer.
 */

import {
  TOGGLE_IDENTITY,
  RESET,
} from '../actions/entitled-photos-identity-filter';

const initialState = {
  hiddenIdentities: [],
};

const entitledPhotosIdentityFilterReducer = (
  state = initialState,
  action = {},
) => {
  switch (action.type) {
    case TOGGLE_IDENTITY:
      return {
        ...state,
        hiddenIdentities: state.hiddenIdentities
          .map(({ id }) => id)
          .includes(action.identity.id)
          ? state.hiddenIdentities.filter(
              identity => identity.id !== action.identity.id,
            )
          : [...state.hiddenIdentities, action.identity],
      };

    case RESET:
      return {
        hiddenIdentities: [],
      };

    default:
      return state;
  }
};

export { initialState };
export default entitledPhotosIdentityFilterReducer;
